import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss';
import Button from '../buttons/Button';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';
import { convertPrice } from './../.././services/convertPrice';
import formatPrice from '../../services/formatPrice';
import checkNaN from '../../services/checkNaN';

const LeasingRateBoxResult = ( props ) => {
    let rateFrequency     = useSelector(state => state.rateFrequency);
    let finalRate         = useSelector(state => state.finalRate);

    useEffect(() => {
        // console.log(finalRate)
    }, [finalRate])
    return (
        <div className="leasing-rate-box result-box">
            <div className="wrapper">
                { rateFrequency == 'kwartalnie' && 
                    <div className={"row active"}>
                        <div className="text-rate">
                            Rata kwartalna (4 raty w roku)
                        </div>
                        {finalRate &&
                            <div className="price">
                                { checkNaN(formatPrice(finalRate)) } netto
                            </div>
                        }
                    </div>
                }
                
                { rateFrequency == 'miesięcznie' &&
                    <div className={"row active"}>
                        <div className="text-rate">
                            Rata miesięczna (12 rat w roku)
                        </div>
                        {finalRate &&
                            <div className="price">
                                { checkNaN(formatPrice(finalRate)) } netto
                            </div>
                        }
                    </div>
                }

                <div className="texta">{ props.text }</div>
            </div>
        </div>
    )
}

export default LeasingRateBoxResult;